export default __webpack_public_path__ + "static/media/FuturaBook.ed19af44.ttf";